<template>
  <div :class="compact ? 'filepond-compact-root' : 'filepond-default-root'">
    <file-pond
      name='file'
      ref='pond'
      :label-idle="pondLabelIdle"
      :allow-multiple="multiple"
      :accepted-file-types="acceptedTypes"
      :server="serverOptions"
      v-on:init='handleFilePondInit'
      v-on:processfile='handleProcessFile'
    />
  </div>
</template>

<script>
// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)

export default {
  name: 'UploadWidget',
  data: function () {
    return {
      // myFiles: ['cat.jpeg'],
      file_url: '',
      value: ''
    }
  },
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pondLabelIdle () {
      if (this.compact) {
        return "Image: <span class='filepond--label-action'>Browse</span> or drop"
      }
      return "Drop files here or <span class='filepond--label-action'>Browse</span><br><span>File must be either PDF, PNG or JPEG/JPG</span>"
    },
    acceptedTypes () {
      if (this.compact) {
        return 'image/jpeg, image/png'
      }
      return 'image/jpeg, image/png, application/pdf'
    },
    // Uploads go through the store's authenticated axios instance so the
    // Authorization header reaches /upload, which requires a login. FilePond's
    // built-in XHR transport sends no headers. The API answers with the stored
    // file's URL as plain text, which becomes the file's serverId as before.
    serverOptions () {
      const api = this.$store.state.apiInstance
      return {
        process: (fieldName, file, metadata, load, error, progress, abort) => {
          const formData = new FormData()
          formData.append(fieldName, file, file.name)
          const controller = new AbortController()
          api.post('/upload/image-upload', formData, {
            headers: {'Content-Type': 'multipart/form-data'},
            signal: controller.signal,
            timeout: 0,
            onUploadProgress: e => progress(e.lengthComputable, e.loaded, e.total)
          })
            .then(response => load(response.data))
            .catch(err => {
              if (controller.signal.aborted) return
              const errors = err.response && err.response.data && err.response.data.errors
              error(errors && errors[0] ? errors[0].detail : 'Upload failed')
            })
          return {
            abort: () => {
              controller.abort()
              abort()
            }
          }
        }
      }
    }
  },
  methods: {
    handleFilePondInit: function () {
      this.$refs.pond.removeFile()
    },
    handleProcessFile: function (error, file) {
      if (error) {
        return
      }
      this.value = file.serverId
      this.$emit('fileUpdated', file.serverId)
      if (this.compact && this.$refs.pond) {
        this.$nextTick(() => {
          this.removeFiles()
        })
      }
    },
    removeFiles () {
      this.$refs.pond.removeFile()
    },
    getUrl () {
      return this.value
    }
  },
  components: {
    FilePond
  }
}
</script>

<style scoped>
.filepond-compact-root ::v-deep .filepond--root {
  margin-bottom: 0;
  overflow: hidden;
  border-radius: 0.25rem;
}
.filepond-compact-root ::v-deep .filepond--panel-root {
  min-height: 2.5rem;
}
.filepond-compact-root ::v-deep .filepond--drop-label {
  min-height: 2.5rem !important;
  font-size: 0.7rem;
  line-height: 1.25;
  padding: 0.35rem 0.5rem;
}
.filepond-compact-root ::v-deep .filepond--item {
  margin-top: 0.25rem;
}
.filepond-compact-root ::v-deep .filepond--image-preview-wrapper {
  max-height: 3rem;
}
</style>
